// extracted by mini-css-extract-plugin
module.exports = {"container":"MRadioGroup_container__2pL2m","item":"MRadioGroup_item__1MeVw","item__text":"MRadioGroup_item__text__2vSgI","container--col":"MRadioGroup_container--col__2TItz"};